import React from "react";
import * as S from "./AtualizacoesPolitica.style";
import SectionCard from "../SectionCard/SectionCard";

function AtualizacoesPolitica() {
  const informacoes = (
    <>
      <S.PStyled>
        Estamos na <b> versão 5 </b> do nosso Aviso de Privacidade, publicado
        em 04/09/2025.
      </S.PStyled>
      <S.PStyled>
        Esse Aviso poderá ser atualizado, caso haja necessidade. A versão mais
        recente está sempre disponível em nosso site.
      </S.PStyled>
      <S.PStyled>
        Caso você tenha alguma dúvida, temos um encarregado pelo tratamento dos
        seus dados pessoais, junto com uma equipe exclusiva para cuidar desse
        tema. Se você quiser pode fazer as suas solicitações relacionadas a seus
        direitos diretamente através do e-mail abaixo:
      </S.PStyled>
      <S.PStyled>
        Stella He Jin Kim <br />
        <S.LinkStyled
          style={{ paddingLeft: "30px" }}
          href="mailto:dpo@caixaconsorcio.com.br"
        >
          dpo@caixaconsorcio.com.br{" "}
        </S.LinkStyled>
        <br />
      </S.PStyled>
      <S.PStyled>
        Se preferir, você também pode falar em nosso Serviço de Atendimento ao
        Cliente, que está preparado para atender suas dúvidas e solicitações.
      </S.PStyled>
      <S.PStyled>
        <S.LinkStyled href="tel:0800-702 4280">
          <b> 0800 975 1000 </b>
          <br />
        </S.LinkStyled>
        Ligação gratuita de qualquer local do Brasil
      </S.PStyled>
      <S.PStyled>
        Temos o compromisso de melhorar a sua segurança e cuidar da proteção de
        seus dados pessoais e da sua privacidade. Fique à vontade para falar com
        a gente sempre que quiser.
      </S.PStyled>
    </>
  );
  return (
    <SectionCard
      title="Aviso de Privacidade"
      subtext1={informacoes}
      width="100%"
    />
  );
}

export default AtualizacoesPolitica;
